import type { ConditionalOperator } from '@lib/types/component-conditional-display'

export const conditionalCheck = (
  conditionalOperator: ConditionalOperator,
  conditionalWatch: string,
  conditionalValues: string[]
) => {
  if (!conditionalWatch || !conditionalValues.length) {
    return false
  }

  switch (conditionalOperator) {
    case 'equalTo':
      return conditionalValues.includes(conditionalWatch)
    case 'notEqualTo':
      return !conditionalValues.includes(conditionalWatch)
    case 'contains':
      return conditionalValues.some((value) => conditionalWatch.includes(value))
    default:
      return false
  }
}
